import { BaseFieldRenderer } from './base-field-renderer';
import { LastNameFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class LastNameFieldRenderer extends BaseFieldRenderer<LastNameFieldJsonData> {
    protected override get defaultData(): LastNameFieldJsonData {
        return {
            id: '',
            type: 'lastname',
            label: TranslateUtils.LASTNAME_FIELD.LABEL,
            placeholder: TranslateUtils.LASTNAME_FIELD.PLACEHOLDER,
            required: true,
            hiddenLabel: false,
            crmFieldData: {
                mixedType: 'ContactField',
                type: 'Text',
                systemName: 'LastName',
                name: 'Last Name'
            }
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: LastNameFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';
        input.maxLength = 500;

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
